"use client";

import { c as _c } from "react/compiler-runtime";
import { EventFilters, EventFiltersType } from "@/components/common/event-filters";
import Events from "@/components/common/events";
import { EventsLoader } from "@/components/loadings/events-loader";
import { Section } from "@/components/section";
import { Suspense, useState } from "react";
import { useSearchParams } from "next/navigation";
type SchedulesProps = {
  section: PageSections;
  data: {
    seoHeading?: string;
    heading?: string;
    countryCode: string;
  };
};
const Schedules = t0 => {
  const $ = _c(22);
  const {
    data,
    section
  } = t0;
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = Number(searchParams.get("page")) || 1;
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const currentPage = t1;
  let t2;
  if ($[2] !== searchParams) {
    t2 = Number(searchParams.get("perPage")) || 5;
    $[2] = searchParams;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const perPage = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      date: "",
      modeOfTraining: ""
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const [filters, setFilters] = useState(t3);
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = valueOrUpdater => {
      setFilters(valueOrUpdater);
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleFiltersChange = t4;
  let t5;
  if ($[6] !== filters) {
    t5 = <EventFilters filters={filters} onChange={handleFiltersChange} />;
    $[6] = filters;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <EventsLoader />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== currentPage || $[10] !== data.countryCode || $[11] !== filters || $[12] !== perPage) {
    t7 = <Suspense fallback={t6}><Events countryCode={data.countryCode} filters={filters} page={currentPage} perPage={perPage} /></Suspense>;
    $[9] = currentPage;
    $[10] = data.countryCode;
    $[11] = filters;
    $[12] = perPage;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== data.heading || $[15] !== data.seoHeading || $[16] !== section.name || $[17] !== section.sectionClass || $[18] !== section.sectionId || $[19] !== t5 || $[20] !== t7) {
    t8 = <Section id={section.sectionId} className={section.sectionClass} data-title={section.name} title={data.heading} seoTitle={data.seoHeading}>{t5}{t7}</Section>;
    $[14] = data.heading;
    $[15] = data.seoHeading;
    $[16] = section.name;
    $[17] = section.sectionClass;
    $[18] = section.sectionId;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};
export default Schedules;